import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './CommentEntry.module.css';

export const CommentEntry = ({ onSubmit, presetComments = [] }) => {
    const [comment, setComment] = useState('');
    const [showPresets, setShowPresets] = useState(false);
    const [dropdownStyle, setDropdownStyle] = useState({});
    const presetsButtonRef = useRef(null);

    useEffect(() => {
        if (showPresets && presetsButtonRef.current) {
            const rect = presetsButtonRef.current.getBoundingClientRect();
            setDropdownStyle({
                position: 'fixed',
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: 'auto',
                maxWidth: '300px',
                minWidth: '50px',
                zIndex: 1000,
            });
        }
    }, [showPresets]);

    const handleSubmit = () => {
        if (comment.trim()) {
            onSubmit(comment);
            setComment('');
        }
    };

    const handlePresetSelect = (preset) => {
        setComment(preset);
        setShowPresets(false);
    };

    return (
        <div className={styles['comment-entry']}>
            <div className={styles['input-wrapper']}>
                <textarea
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Enter your comment..."
                    rows={3}
                />
                <div className={styles['button-group']}>
                    <button ref={presetsButtonRef} onClick={() => setShowPresets(!showPresets)}>
                        Presets
                    </button>
                    <button onClick={handleSubmit} disabled={!comment.trim()}>
                        Submit
                    </button>
                </div>
            </div>

            {showPresets && presetComments.length > 0 && (
                <div className={styles['presets-dropdown']} style={dropdownStyle}>
                    {presetComments.map((preset, idx) => (
                        <button
                            key={idx}
                            onClick={() => handlePresetSelect(preset)}
                            className={styles['preset-option']}
                        >
                            {preset}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

CommentEntry.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    presetComments: PropTypes.arrayOf(PropTypes.string),
};

CommentEntry.defaultProps = {
    presetComments: ["Mechanical Issue", "Electrical Issue", "Tooling/Change Over", "Material Shortage", "Manpower", "Planning", "Power Outage", "QA Hold"],
};